import { useRef, useState } from "react"
import { useLocation } from "react-router-dom"

import { MessageModal, SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { APIS } from "../../config/apis"
import { OPERATION_MODE, REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from "../../utils/apiweb"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import TipoArrendamientoModal from "../../components/controls/TipoArrendamientoModal"
import { PERMISSIONS } from "../../consts/permissions"
import { useSearchParams } from "react-router-dom"
const TipoArrendamientosView = () => {
    const { setIsLoading } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [data, setData] = useState([])
    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()
    const [tableVisible, setTableVisible] = useState(false)
    const [removingId, setRemovingId] = useState(null)

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const [searchParams] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const isViewOnly = searchParams.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const SearchTipoArrendamientos = () => {
        const { filters } = searchRef.current
        const params = `/filter?codigo=${filters.codigo}&nombre=${filters.nombre}&esEmbarcacion=${filters.esEmbarcacion}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ARRENDAMIENTO,
            params,
            null,
            res => res.json().then(data => {
                setData(data)
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                orden: '',
                nombre: '',
                idTasaInicialRenovacion: 0,
                idSubTasaInicialRenovacion: 0,
                idTasaTransferencia: 0,
                idSubTasaTransferencia: 0,
                idTasaMensual: 0,
                idSubTasaMensual: 0,
                idTasaExpensas: 0,
                idSubTasaExpensas: 0,
                idSubTasaVarios: 0,
                esEmbarcacion: false
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: (item) => {
            setRemovingId(item.id)
        }
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.TIPO_ARRENDAMIENTO,
            `/${id}`,
            null,
            () => {
                setData(prev => prev.filter(x => x.id !== id))
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
        setRemovingId(null)
    }

    const onModalConfirm = () => {
        setEditMode(null)
        setEditItem(null)
        if (tableVisible) SearchTipoArrendamientos()
    }

    const onCancelEdit = () => {
        setEditMode(null)
        setEditItem(null)
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Tipos de arrendamientos' }]}
                        onAddClick={allowEditActions ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className='section-accordion'>

            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 2 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 3 },
                    {
                        title: 'Tipo',
                        field: 'esEmbarcacion',
                        type: 'segmented',
                        size: 3,
                        options: [
                            { value: null, label: 'Todos' },
                            { value: true, label: 'Embarcación' },
                        ],
                    }
                ]}
                onSearch={SearchTipoArrendamientos}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={data}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '20%', },
                        { Header: 'Es embarcación', accessor: 'esEmbarcacion', width: '20%', Cell: ({ value }) => value ? 'Sí' : 'No' },
                    ]}
                />
            )}

            {editItem && (
                <TipoArrendamientoModal
                    tipoArrendamiento={editItem}
                    editMode={editMode}
                    onConfirm={onModalConfirm}
                    onCancel={onCancelEdit}
                />
            )}

            {removingId && 
                <MessageModal
                    title={"Confirmación"}
                    message={"¿Está seguro de borrar el registro?"}
                    onDismiss={() => setRemovingId(null)}
                    onConfirm={() => confirmRemoveId(removingId)}
                />
            }
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default TipoArrendamientosView
